var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-modal",class:{ 'c-modal--open': _vm.open }},[(_vm.innerOpen)?_c('div',{staticClass:"c-modal__inner",class:_vm.innerClass},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }